import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './AppIcon';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date()?.getFullYear();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleWhatsAppOrder = () => {
    window.open('https://wa.me/211915497014?text=Hello%20Chapati%20Plus!%20I%20would%20like%20to%20place%20an%20order.', '_blank');
  };

  const quickLinks = [
    { label: 'Home', path: '/homepage' },
    { label: 'Menu', path: '/menu' },
    { label: 'About Us', path: '/about' },
    { label: 'Gallery', path: '/gallery' },
  ];

  const supportLinks = [
    { label: 'Contact Us', path: '/contact' },
    { label: 'Order Now', path: '/order-now' },
    { label: 'FAQs', path: '/contact' },
    { label: 'Delivery Info', path: '/about' },
  ];

  const socialLinks = [
    { name: 'Facebook', icon: 'Facebook', url: 'https://www.facebook.com/share/1DTesqbAeA/?mibextid=wwXIfr' },
    { name: 'Instagram', icon: 'Instagram', url: 'https://www.instagram.com/chapatiplusssd/' },
    { name: 'Twitter', icon: 'Twitter', url: 'https://twitter.com/chapatiplus' },
    { name: 'WhatsApp', icon: 'MessageCircle', url: 'https://wa.me/211915497014' },
  ];

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-grid">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center overflow-hidden">
                <img src="/assets/images/logo-1767562373802.jpeg" alt="Chapati Plus Logo" className="w-full h-full object-contain" />
              </div>
              <span className="text-primary font-bold text-xl font-heading">Chapati Plus</span>
            </div>
            <p className="text-muted-foreground mb-4">
              Authentic South Sudanese flavors delivered fresh to your door. Experience the taste of tradition with modern convenience.
            </p>
            <p className="footer-tagline">Taste The Difference</p>
          </div>

          <div>
            <h3 className="footer-section-title">Quick Links</h3>
            <nav className="flex flex-col">
              {quickLinks?.map((link) => (
                <button
                  key={link?.path}
                  onClick={() => handleNavigation(link?.path)}
                  className="footer-link text-left"
                >
                  {link?.label}
                </button>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="footer-section-title">Support</h3>
            <nav className="flex flex-col">
              {supportLinks?.map((link) => (
                <button
                  key={link?.path}
                  onClick={() => handleNavigation(link?.path)}
                  className="footer-link text-left"
                >
                  {link?.label}
                </button>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="footer-section-title">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-2 text-muted-foreground">
                <Icon name="MapPin" size={18} className="mt-1 flex-shrink-0" />
                <span>Juba, South Sudan</span>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground">
                <Icon name="Phone" size={18} className="flex-shrink-0" />
                <a href="tel:+211915497014" className="hover:text-primary transition-colors">
                  +211 915 497 014
                </a>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground">
                <Icon name="Mail" size={18} className="flex-shrink-0" />
                <a href="mailto:hello@chapatiplus.com" className="hover:text-primary transition-colors">
                  hello@chapatiplus.com
                </a>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground">
                <Icon name="Clock" size={18} className="flex-shrink-0" />
                <span>Daily: 8:00 AM - 10:00 PM</span>
              </div>
            </div>
            <div className="footer-social">
              {socialLinks?.map((social) => (
                <a
                  key={social?.name}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  aria-label={social?.name}
                >
                  <Icon name={social?.icon} size={20} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Chapati Plus. All rights reserved.
          </p>
          <div className="flex gap-4 text-sm text-muted-foreground">
            <button onClick={() => handleNavigation('/contact')} className="hover:text-primary transition-colors">
              Privacy Policy
            </button>
            <span>•</span>
            <button onClick={() => handleNavigation('/contact')} className="hover:text-primary transition-colors">
              Terms of Service
            </button>
          </div>
          <div className="mt-2 text-sm text-muted-foreground">
            <span>Website by </span>
            <a 
              href="https://kairosholding.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:underline font-medium"
            >
              Kairos
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;